<template>
  <div>
    <form class="form" @submit.prevent="updateEmail">
      
      <!-- email -->
      <div class="form-group">
        <label class="form-label required" for="email">{{ $t('edit_email.new') }}</label>
        <input
          type="email"
          class="form-control"
          :class="{'is-invalid' : (error.email||error.email2) }"
          id="email"
          v-model="form.email"
          :disabled="loading"
        />
        <div class="invalid-feedback" v-show="error.email">
          <span>{{ error.email }}</span>
        </div>
      </div>
      <!-- email -->
      <!-- email2 -->
      <div class="form-group">
        <label class="form-label required" for="email2">{{ $t('edit_email.new_confirm') }}</label>
        <input
          type="email"
          class="form-control"
          :class="{'is-invalid' : error.email2 }"
          id="email2"
          v-model="email2"
          :disabled="loading"
        />
        <div class="invalid-feedback" v-show="error.email2">
          <span>{{ $t('edit_email.confirm_error') }}</span>
        </div>
      </div>
      <!-- email2 -->

      <button type="submit" class="button button-primary" :disabled="loading">
        <span v-show="loading">{{ $t('common.button.update') }}</span>
        <span v-show="!loading">{{ $t('common.button.update') }}</span>
      </button>
    </form>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {api} from "../../../config";

  export default {
    data() {
      return {
        loading: false,
        error: {
          email: '',
          email2: null
        },
        email2: null
      };
    },
    computed: mapState({
      form: state => {
        return {...state.auth};
      }
    }),
    methods: {
      updateEmail() {
        let self = this;
        
        this.loading = true;
        
        if(this.form.email != this.email2) {
          this.loading = false;
          this.setErrors2()
          return false
        }
        
        self.$store.dispatch('showLoading', true);
        
        axios.post(api.updateEmail, this.form)
          .then((res) => {
            self.loading = false;
            self.$store.dispatch('currentAuthUser');
            self.$store.dispatch('showLoading', false);
            
            self.$emit('updateSuccess', res.data);
          })
          .catch(err => {

            (err.response.data.error)
              ? self.setErrors(err.response.data.error)
              : self.clearErrors();

            self.loading = false;
            self.$store.dispatch('showLoading', false);
          });
      },
      setErrors(errors) {
        this.error.email = errors.email ? errors.email[0] : null;
      },
      setErrors2() {
        this.error.email2 = true;
      },
      clearErrors() {
        this.error.email = null;
        this.error.email2 = null;
      }
    }
  }
</script>